import {register} from '../vendor/theme-scripts/theme-sections';
import {accordion} from '../features/accordion';

register('page-faq', accordion);
